import {DateTime} from "luxon";


export default {
    methods:{
        timeFromISOToFormat(_datTime){
            return  DateTime.fromISO(_datTime ).toFormat('T');
        }
    },



}